interface XAPIActor {
  account?: { name: string };
  objectType: string;
}

interface XAPIVerb {
  id: string;
  display: { [key: string]: string };
}

interface XAPIObject {
  id: string;
  objectType: string;
  definition?: { extensions?: { [key: string]: any } };
}

interface XAPIContextActivity {
  id: string;
  objectType: string;
}

interface XAPIContextActivities {
  category?: XAPIContextActivity[];
}

interface XAPIContext {
  contextActivities?: XAPIContextActivities;
}

interface XAPIStatement {
  actor: XAPIActor;
  verb: XAPIVerb;
  object: XAPIObject;
  context?: XAPIContext;
}

interface XAPIEvent {
  type: "xAPI";
  data: { statement: XAPIStatement };
}

interface H5PEventXAPI {
  constructor: Function;
  getContentXAPIId(e?: any): any;
  getMaxScore(): number;
  getScore(): number;
  getVerb(e?: any): any;
  getVerifiedStatementValue(e?: any): any;
  isFromChild(): boolean;
  setActor(e: any): void;
  setContext(t: any): void;
  setObject(t: any): void;
  setScoredResult(e: any, t: any, n: any, r: any, i: any): void;
  setVerb(t: any): void;
}

interface H5PEvent extends H5PEventXAPI {
  data: any;
}

export interface H5PContentConfig {
  baseUrl: string;
  url: string;
  contents: {
    [contentId: string]: H5PContent;
  };
  saveFreq?: number;
  postUserStatistics?: boolean;
  ajax?: Record<string, any>;
  l10n?: Record<string, any>;
  core?: {
    styles?: string[];
    scripts?: string[];
  };
  urlLibraries?: string;
  reportingIsEnabled?: boolean;
}

export interface H5PContent {
  library: string;
  title: string;
  url: string;
  contentUrl: string;
  jsonContent: string;
  styles: string[];
  scripts: string[];
  fullScreen: boolean;
  embedCode: string;
  resizeCode: string;
  displayOptions: {
    copyright: boolean;
    embed: boolean;
    export: boolean;
    frame: boolean;
    icon: boolean;
    copy: boolean;
  };
  contentUserData: Array<{
    state: string;
  }>;
  metadata: {
    title: string;
    license: string;
  };
}

interface H5PStandaloneOptions {
  h5pJsonPath: string;
  frameCss: string;
  frameJs: string;
  id?: string;
  librariesPath?: string;
  contentJsonPath?: string;
  frame?: boolean;
  copyright?: boolean;
  export?: boolean;
  icon?: boolean;
  downloadUrl?: string;
  fullScreen?: boolean;
  embed?: boolean;
  embedCode?: string;
  customCss?: string | string[];
  customJs?: string | string[];
  xAPIObjectIRI?: string;
  saveFreq?: number;
  contentUserData?: object;
  postUserStatistics?: boolean;
  ajax?: Ajax;
  user?: User;
}

interface Ajax {
  contentUserDataUrl?: string;
  setFinishedUrl?: string;
}

interface User {
  name?: string;
  mail?: string;
}

interface QuizData {
  h5pId: string;
  chapterId: any;
  maxScore: any;
  raw: any;
}

const frameJs =
  "https://cdn.jsdelivr.net/npm/h5p-standalone@3.8.0/dist/frame.bundle.js";
const frameCss =
  "https://cdn.jsdelivr.net/npm/h5p-standalone@3.8.0/dist/styles/h5p.css";

export {
  frameCss,
  frameJs,
  H5PEvent,
  H5PStandaloneOptions,
  XAPIEvent,
  QuizData,
};
